
/* Construit le bouton « Aide » et son panneau, au-dessus de 1000 px.
   Les liens sont CLONES depuis nav.alm-inav--right (menu Shopify) : aucune
   adresse en dur. Le bouton est pose comme premier enfant de .mz-actions,
   donc a gauche des icones, sans calcul de position. */
(function () {
  var SOUS = {
    'suivi de commande': 'Où en est mon colis',
    'faq': 'Pose, entretien, garantie',
    'blog': 'Conseils lumière',
    'nous contacter': "Écrire à l'équipe",
    'contact': "Écrire à l'équipe"
  };
  var enAttente = false;

  function pc() { return window.innerWidth >= 1001; }

  /* le logo est servi en 400 px : trop peu des que l'ecran est en 1,5x ou 2x */
  function logoNet() {
    var img = document.querySelector('#mzHeaderLogo .mz-logo-img');
    if (!img || img.getAttribute('data-alm-net') === '1') { return; }
    var src = img.currentSrc || img.src || '';
    if (src.indexOf('_400x') === -1) { img.setAttribute('data-alm-net', '1'); return; }
    img.setAttribute('srcset', '');
    img.src = src.replace('_400x', '_1200x');
    img.setAttribute('data-alm-net', '1');
  }

  function construire() {
    enAttente = false;
    var h = document.getElementById('mzHeader');
    if (!h || !pc()) { return; }
    logoNet();
    if (h.querySelector('.alm-aide')) { return; }

    var source = h.querySelector('.alm-inav--right');
    var actions = h.querySelector('.mz-actions');
    if (!source || !actions) { return; }

    var liens = [].slice.call(source.querySelectorAll('a')).filter(function (a) {
      return a.getAttribute('href') && a.textContent.trim();
    });
    if (!liens.length) { return; }

    /* on ajoute « Nous contacter » du bandeau s'il existe, sans le retirer de la */
    var contact = h.querySelector('.mz-ann-cta');
    if (contact && contact.getAttribute('href')) { liens.push(contact); }

    /* EQUILIBRE : mesure a 1280 px, le bloc de gauche fait 413 px et celui
       de droite 183 — un rapport de 2,3. Le logo est au centre exact mais
       l'oeil voit lourd a gauche. On deplace la derniere entree du menu de
       gauche (La Marque) vers la droite : 2 entrees de chaque cote. */
    var listeG = h.querySelector('.alm-inav--left .alm-inav-list');
    if (listeG && listeG.children.length > 2 && !h.querySelector('.alm-equilibre')) {
      var dernier = listeG.children[listeG.children.length - 1];
      var lien = dernier.querySelector('a');
      if (lien) {
        var report = document.createElement('a');
        report.className = 'alm-equilibre alm-inav-link';
        report.href = lien.getAttribute('href');
        report.textContent = lien.textContent.trim();
        actions.insertBefore(report, actions.firstChild);
        /* le masquage de l'original se fait en CSS (voir bloc 2c) :
           en JavaScript il sautait des que le theme reconstruisait le menu */
      }
    }

    var enveloppe = document.createElement('span');
    enveloppe.className = 'alm-aide';

    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'alm-aide-btn';
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-haspopup', 'true');
    bouton.innerHTML = '<span class="alm-aide-mot">Aide</span><span class="alm-aide-chev" aria-hidden="true">⌄</span>';

    var pan = document.createElement('div');
    pan.className = 'alm-aide-pan';
    var boite = document.createElement('div');
    boite.className = 'alm-aide-boite';
    var tete = document.createElement('div');
    tete.className = 'alm-aide-tete';
    var sur = document.createElement('span');
    sur.className = 'alm-aide-sur';
    sur.textContent = 'Service';
    var titre = document.createElement('span');
    titre.className = 'alm-aide-titre';
    titre.textContent = 'Un coup de main ?';
    tete.appendChild(sur);
    tete.appendChild(titre);
    boite.appendChild(tete);

    /* l'ordre utile : le suivi de commande d'abord */
    liens.sort(function (a, b) {
      var ta = a.textContent.trim().toLowerCase(), tb = b.textContent.trim().toLowerCase();
      return (ta.indexOf('suivi') === 0 ? 0 : 1) - (tb.indexOf('suivi') === 0 ? 0 : 1);
    });

    liens.forEach(function (a) {
      var titre = a.textContent.trim();
      var lien = document.createElement('a');
      lien.className = 'alm-aide-lien';
      lien.href = a.getAttribute('href');
      var fort = document.createElement('strong');
      fort.textContent = titre;
      lien.appendChild(fort);
      var s = SOUS[titre.toLowerCase()];
      if (s) {
        var sous = document.createElement('span');
        sous.textContent = s;
        lien.appendChild(sous);
      }
      boite.appendChild(lien);
    });

    var pied = document.createElement('div');
    pied.className = 'alm-aide-pied';
    pied.textContent = 'Livraison offerte · Garantie 2 ans';
    boite.appendChild(pied);

    pan.appendChild(boite);
    enveloppe.appendChild(bouton);
    enveloppe.appendChild(pan);
    actions.insertBefore(enveloppe, actions.firstChild);

    var minuteur = null;
    function ouvrir() {
      clearTimeout(minuteur);
      enveloppe.classList.add('ouvert');
      bouton.setAttribute('aria-expanded', 'true');
    }
    function fermer(delai) {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () {
        enveloppe.classList.remove('ouvert');
        bouton.setAttribute('aria-expanded', 'false');
      }, delai || 0);
    }
    enveloppe.addEventListener('mouseenter', ouvrir);
    enveloppe.addEventListener('mouseleave', function () { fermer(160); });
    enveloppe.addEventListener('focusin', ouvrir);
    enveloppe.addEventListener('focusout', function (e) {
      if (!enveloppe.contains(e.relatedTarget)) { fermer(0); }
    });
    bouton.addEventListener('click', function (e) {
      e.preventDefault();
      if (enveloppe.classList.contains('ouvert')) { fermer(0); } else { ouvrir(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { fermer(0); }
    });
    document.addEventListener('click', function (e) {
      if (!enveloppe.contains(e.target)) { fermer(0); }
    });
  }

  function planifier() {
    if (enAttente) { return; }
    enAttente = true;
    if (window.requestAnimationFrame) { window.requestAnimationFrame(construire); }
    else { setTimeout(construire, 16); }
  }

  construire();
  document.addEventListener('DOMContentLoaded', construire);
  window.addEventListener('load', construire);
  window.addEventListener('resize', planifier, { passive: true });
  setTimeout(construire, 500);
  setTimeout(construire, 1500);
})();
